<template>
    <div class="main_body">
        <!-- <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" /> -->
        <div class="container-fluid">
            <div style="margin-left:20px;" class="pb-4">
                <h2>AudioBook Analytics</h2>
            </div>            
            <div class="align-items-center justify-content-center text-center">
                <div class="btn-group" role="group" aria-label="Basic example">
                    <button @click="transaction" class=" btn btn-primary" type="button" aria-expanded="false"
                        aria-controls="collapseExample">Last Transaction List</button>
                    <button @click="failedTransaction" class=" btn btn-primary" type="button" aria-expanded="false"
                        aria-controls="collapseExample">Last Failed Transaction List</button>
                    <button @click="signupHistory" class=" btn btn-primary" type="button" aria-expanded="false"
                        aria-controls="collapseExample">Signup History</button>
                    <button @click="signupHistoryChannel" class=" btn btn-primary" type="button"
                        aria-expanded="false" aria-controls="collapseExample">Signup History Channel</button>
                    <button @click="listened" class=" btn btn-primary" type="button" aria-expanded="false"
                        aria-controls="collapseExample">Most listened audio</button>
                    <button @click="purchased" class=" btn btn-primary" type="button" aria-expanded="false"
                        aria-controls="collapseExample">Most purchased audio</button>
                    <button @click="rated" class=" btn btn-primary" type="button" aria-expanded="false"
                        aria-controls="collapseExample">Most rated audio</button>
                </div>
            </div>
            <div class="row mt-5">
                <div v-if="flag1 === true" class="collapse show" id="collapseExample1">
                    <LastTransactionList></LastTransactionList>
                </div>
                <div v-if="flag2 === true" class="collapse show" id="collapseExample2">
                    <LastFailedTransactionList></LastFailedTransactionList>
                </div>
                <div v-if="flag3 === true" class="collapse show" id="collapseExample2">
                    <SignupHistory></SignupHistory>
                </div>
                <div v-if="flag4 === true" class="collapse show" id="collapseExample2">
                    <signupHistoryChannel></signupHistoryChannel>
                </div>
                <div v-if="flag5 === true" class="collapse show" id="collapseExample2">
                    <AudioBookMostlistened></AudioBookMostlistened>
                </div>
                <div v-if="flag6 === true" class="collapse show" id="collapseExample2">
                    <AudioBookMostPurchased></AudioBookMostPurchased>
                </div>
                <div v-if="flag7 === true" class="collapse show" id="collapseExample2">
                    <AudioBookMostRated></AudioBookMostRated>
                </div>
            </div>
            <div class="row mt-5">
                <div v-if="loadFlag === true" class="collapse show" id="collapseExample1">
                    <LastTransactionList></LastTransactionList>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LastTransactionList from './LastTransactionList'
import LastFailedTransactionList from './LastFailedTransactionList';
import SignupHistory from './SignupHistory';
import SignupHistoryChannel from './SignupHistoryChannel';
import AudioBookMostlistened from './AudioBookMostlistened';
import AudioBookMostPurchased from './AudioBookMostPurchased';
import AudioBookMostRated from './AudioBookMostRated';
export default {
    data() {
        return {
            flag1: false,
            flag2: false,
            flag3: false,
            flag4: false,
            flag5: false,
            flag6: false,
            flag7: false,
            loadFlag:true
        }
    },

    components: {
        LastTransactionList,
        LastFailedTransactionList,
        SignupHistory,
        SignupHistoryChannel,
        AudioBookMostlistened,
        AudioBookMostPurchased,
        AudioBookMostRated
    },

    methods: {
        transaction() {
            this.flag1 = !this.flag1
            this.flag2 = false
            this.flag3 = false
            this.flag4 = false
            this.flag5 = false
            this.flag6 = false
            this.flag7 = false
this.loadFlag = false
        },
        failedTransaction() {
            this.flag2 = !this.flag2
            this.flag1 = false
            this.flag3 = false
            this.flag4 = false
            this.flag5 = false
            this.flag6 = false
            this.flag7 = false
            this.loadFlag = false
        },
        signupHistory() {
            this.flag3 = !this.flag3
            this.flag1 = false
            this.flag2 = false
            this.flag4 = false
            this.flag5 = false
            this.flag6 = false
            this.flag7 = false
            this.loadFlag = false
        },
        signupHistoryChannel() {
            this.flag4 = !this.flag4
            this.flag1 = false
            this.flag2 = false
            this.flag3 = false
            this.flag5 = false
            this.flag6 = false
            this.flag7 = false
            this.loadFlag = false
        },
        listened() {
            this.flag5 = !this.flag5
            this.flag1 = false
            this.flag2 = false
            this.flag3 = false
            this.flag4 = false
            this.flag6 = false
            this.flag7 = false
            this.loadFlag = false
        },
        purchased() {
            this.flag6 = !this.flag6
            this.flag1 = false
            this.flag2 = false
            this.flag3 = false
            this.flag4 = false
            this.flag5 = false
            this.flag7 = false
            this.loadFlag = false
        },
        rated() {
            this.flag7 = !this.flag7
            this.flag1 = false
            this.flag2 = false
            this.flag3 = false
            this.flag4 = false
            this.flag5 = false
            this.flag6 = false
            this.loadFlag = false
        }
    }
}
</script>
<style>
    .btn-group button{
        background: black;
    }
</style>